export default function Sass_List() {
  return (
    <div>
      <h1>Sass List</h1>
    </div>
  );
}
